module.exports = __webpack_public_path__ + "img/ms.672d771.svg";